module.exports = __webpack_public_path__ + "img/img16.33512dac.svg";